function DashboardHome() {
  return (
    <>
      <main>
        <h2>DashboardHome</h2>
      </main>
    </>
  );
}

export default DashboardHome;
